import filter from 'lodash/filter';

import Notification from '~/components/AccountNotification';

export default function AccountNotifications({
  className,
  notifications,
  isFromEnrichmentPage,
}) {
  const unresolvedNotifications = filter(
    notifications,
    (notification) => !notification.resolved,
  );

  if (unresolvedNotifications.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {unresolvedNotifications.map((notification) => (
        <Notification
          accountNotification={notification}
          key={notification.id}
          isFromEnrichmentPage={isFromEnrichmentPage}
        />
      ))}
    </div>
  );
}

AccountNotifications.defaultProps = {
  isFromEnrichmentPage: false,
};

AccountNotifications.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.array,
  isFromEnrichmentPage: PropTypes.bool,
};
